import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { Plate } from '../models/plate';
import { MaPlatePreparationService } from '../ma-plate-preparation/ma-plate-preparation.service';
import { MessagesService } from '../messages/messages.service';
import { Step } from '../models/step';
import { ErrorHandler } from '../utils/error-handler';
import { MasterDataService } from '../masterdata/masterdata.service';
import { WorkFlow } from '../masterdata/models/workFlow';
import { ProcessStepStage } from '../models/process-step-stages';
import { StepAction } from '../models/step-action';
import { BeadChip } from '../models/bead-chip';
import { Comment } from '../models/comment';
import { BeadChipProcessStep, BeadChipStatus, PlateStatus, ProcessStep } from '../models/process-step';
import { BeadChipAction } from '../models/action';
import { MultiCommentDTO } from '../ma-comments-popup/comment-dto';
import { Machine } from '../masterdata/models/machine';
import { BeadChipProcessFlows } from '../models/process-flows';
import { ProcessFlow } from '../masterdata/models/processFlow';
import { LoadBeadchipOFH } from '../models/load-beadchip';
import { MultiPlateUpdate } from '../ma-plate-preparation/multiplate-update-dto';
import { Action } from '../models/action';
import { AnnouncedService } from '../apg-announced/services/announced.service';
import { PlateType } from '../models/plateid-types-enum';
import { MaStorageService } from '../ma-storage/ma-storage.service';
import { saveAs as saveByFileSaver } from "file-saver";
import { priorityMap } from '../utils/priority-row';
import {showLatestComment} from "../utils/latest-comment-util";
import { formatDate, DatePipe } from "@angular/common";
import { PlateListDTO } from '../dto/plateListDTO';

const BEADCHIP_COMPLETED_STATUSES = [BeadChipStatus.GENE_TITAN_LOADED, BeadChipStatus.COMPLETED]

@Component({
  selector: 'app-ma-beadchip-loading',
  templateUrl: './ma-beadchip-loading.component.html',
  styleUrls: ['./ma-beadchip-loading.component.css']
})
export class MaBeadchipLoadingComponent implements OnInit {
  // Component Variables
  @Input() plates:Plate[];
  @Input() beadchipPlates: Plate[];
  @Input() isBeadChipLoadingSelectedFromSamplesComponent: boolean = false;
  @Input() scannedPlateID: string = null;
  @Input() selectedPlateType: string = null;

  errorHandler: ErrorHandler = new ErrorHandler;
  readonly showLatestComment = showLatestComment;
  readonly BEADCHIP_EXCLUDED_STATUSES = [BeadChipStatus.BEADCHIP_IMAGED, BeadChipStatus.COMPLETED, BeadChipStatus.DELIVERED, BeadChipStatus.PLATE_REDO];
  blocked = false;
  puid: string;
  selectedLabId: string;
  showPlateView: boolean;
  selectedWorkFlow: WorkFlow;
  workFlowData: WorkFlow[] = [];
  workFlowMap: Map<string, WorkFlow> = new Map();
  beadChipToSearch: string;
  sampleToSearch: string;
  plateSelection : boolean;
  plateTableloading : boolean;
  beadChipTableloading: boolean;
  beadChipSelectedRow : Plate;
  tableSelectedRow : Plate;
  selectedStatuses: string[] = [];
  filterOptions: any[];
  processFlows: ProcessFlow[] = []
  selectedProcessFlowList: string[] = [];
  protocolsList = [];
  selectedProtocolList: string[] = [];
  fromDate: Date = new Date();
  completeIncubationDate:Date = null
  machinesList: Machine[];
  machinesBarcodeMap: Map<string, Machine> = new Map();
  beadChipViewSelected: boolean = false;
  axiom384PlateBool: boolean = false;
  plateSelected: boolean = false;
  plateViewSelectionDone: boolean = false;

  selectedPlate: Plate;
  selectedPlateStepsMap: Map<string, Step>;
  selectedPlateStatus:string="";
  selectedBeadChipPlate: Plate;
  selectedBeadchipStatus:string="";
  beadChipDetails: Plate
  multiUpdateProcessStepsMap :Map<string, Step>;
  mapOfStatusSaves = new Map();
  mapOfProcessStepsFlow : Map<string, string[]> = new Map();
  mapOfProcessStepAndAction : Map<string, string[]> = new Map();
  mapOfActionRuntime : Map<string, number> = new Map();
  selectedProcessFlow: string = "";
  selectedProcessFlowConfig: ProcessFlow = new ProcessFlow();
  axiom384Plate1: Plate = new Plate();
  axiom384PlateID1: String = "";
  // OFH BeadChip Loading
  scannedPlate1: Plate;
  scannedPlate1StepsMap: Map<string, Step>;
  scannedPlate2: Plate;
  scannedPlate2StepsMap: Map<string, Step>;
  scannedPlate3: Plate;
  scannedPlate3StepsMap: Map<string, Step>;
  beadchip1LayoutMapping : Map<string, string> = new Map();
  beadchip2LayoutMapping : Map<string, string> = new Map();

  // Chemical Pop Up Variables
  noChemicalEdit : boolean;
  multiChemicalEdit: boolean;
  showDialogue= false;
  chemicalsBeadChipids: any[] = [];
  mapOfProcessStepsStatus = new Map();
  selectedProcessStep: string;
  processStepChemicals: any;

  // Comments Pop Up Variables
  showCommentDialog : boolean = false;
  beadChipCommentsMap :Map<string, Comment[]> = new Map<string, Comment[]>();
  beadChipCommentsDisplayMap:Map<string, boolean> = new Map<string, boolean>();
  plateCommentsList: Comment[]=[];
  fetchedCommentsPlate : Plate;
  selectedPlateID : string ="";
  commentplateID : string ="";

  // Multi Update Pop Up Variables
  showConfirmBeadChipsPopup = false;
  showConfirmPlatesPopup = false;
  multiBeadChip = true;
  multiUpdateButtonStyleClass: string;
  multiUpdateInputLabel: string;
  multiUpdateStatusLabel: string;
  multiUpdateBeadChipList: Array<any>;
  multiUpdateSamplesList: Map<string, string[]> = new Map<string, string[]>();
  multiUpdatePlateList: Array<any>;
  multiUpdatePlateInfoList: Array<any>;
  enteredBeadChipId: string;
  fetchedBeadChipPlate: Plate;
  enteredPlateId: string;
  fetchedPlate: Plate;
  multiStage: number;
  multiStepName: string;
  multiActionName: string;
  multiActionPos: number;
  multiUpdateStatus : string;
  mapOfStatusAndLabel = new Map();
  multiBeadChipStepsMap: Map<string, Step>;
  multiBeadChipStepsMapList: Array<Map<string, Step>>;
  multiPlateStepsMap: Map<string, Step>;
  multiPlateStepsMapList: Array<Map<string, Step>>;
  lastUpdatedBeadChips1: any[] = []
  lastUpdatedBeadChips2: any[] = []
  lastUpdatedBeadChips3: any[] = []
  showMultipleCommentDialog = false;
  lastUpdatedStatus: string;
  newMultiComment: string = '';
  longtimeStorageList : Array<any> = [];
  wgaStoreDialog: boolean = false
  enteredWgaPlateID: string = ''
  multiWgaPlateID: Array<string> = []
  selectedStorageLocation: string = ''
  multiOldStorageList: Set<string>;

  // Log File Variables
  isFileNotSelected : boolean = true;
  uploadedFile : File;
  uploadedFileContent : any;
  @ViewChild('manualfileUpload')
  fileUploadElement: ElementRef;
  showDueDate = false;

  constructor(
      private readonly platePreparationService:MaPlatePreparationService,
      private readonly masterDataService: MasterDataService,
      private readonly _messagesService: MessagesService,
      private readonly announcementService:AnnouncedService,
      private readonly _maStorageService:MaStorageService,
      private readonly datePipe:DatePipe
  ) { }

  ngOnInit() {
    this.puid = localStorage.getItem("PUID");
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.selectedWorkFlow = JSON.parse(localStorage.getItem('selectedWorkFlow'));
    const isDateRange = JSON.parse(localStorage.getItem('lab')).lab.dateRange;
    this.showPlateView = false;
    this.selectedPlateStepsMap = new Map();
    this.multiUpdateProcessStepsMap = new Map();

    if (isDateRange) {
      this.fromDate.setDate(new Date().getDate() - 5);
    } else {
      this.fromDate.setDate(new Date().getDate() - 31);
    }

    this.setStatusFilterOptions();
    this.getAllActiveWorkFlowList();
    this.fetchReceivedPlates(); 
    this.fetchBeadchips();
    this.getAllProcessFlows();
    this.fetchAllActiveMachines();
    this.setMapOfStatusSaves();
    this.setMapOfProcessStepsStatus();
    this.setMapOfProcessStepsFlow();
    this.setMapOfProcessStepAndAction();
    this.setMapOfActionRuntime();
    this.setMapOfStatusAndLabel()
    this.protocolsList = [
      { label: "Illumina Ex Infinium", value: "illuminaExInfinium"},
      { label: "Axiom384 Propel", value: "axiom384Propel"},
    ]
    this.plateSelection = true;
    this.resetData();
    this.prepareBeadchipLayoutMaps();

    this.multiUpdateButtonStyleClass= "";
    this.multiUpdateInputLabel= "";
    this.multiUpdateStatusLabel= "";
    this.multiUpdateBeadChipList= [];
    this.enteredBeadChipId= "";
    this.multiBeadChipStepsMapList = new Array();
    this.multiUpdatePlateList= [];
    this.multiUpdatePlateInfoList = [];
    this.enteredPlateId= "";
    this.multiPlateStepsMapList = new Array();

    if(this.scannedPlateID) {
      let event = {
        'data' : {
          'plateID' : this.scannedPlateID
        }
      }
      if(this.selectedPlateType == PlateType.PLATE) {
        this.fetchPlate(event);
      } else {
        this.fetchBeadchip(event);
      }
      this.scannedPlateID = null;
    } else {
      this.assignPlateView();
    }
    this.multiOldStorageList = new Set();
    this.fetchStorageLocationList()
  }

  setStatusFilterOptions(){
    this.filterOptions = [
      { label: 'Loaded', value: BeadChipStatus.LOADED},
      { label: 'Hybridization Started', value: BeadChipStatus.HYBRIDIZATION_STARTED },
      { label: 'Hybridization Completed', value: BeadChipStatus.HYBRIDIZATION_COMPLETED},
      { label: 'Incubate 48°C', value: BeadChipAction.INCUBATE_48C},
      { label: 'Wash & Stain Prep', value: BeadChipAction.WASH_AND_STAIN_PREP},
      { label: 'Waiting For Analysis', value: BeadChipStatus.WAITING_FOR_ANALYSIS},
      { label: 'Gene Titan Loaded', value: BeadChipStatus.GENE_TITAN_LOADED},
      { label: 'Incubation Started', value: BeadChipStatus.INCUBATION_STARTED},
      { label: 'Incubation Completed', value: BeadChipStatus.INCUBATION_COMPLETED},
      { label: 'Staining Started', value: BeadChipStatus.STAINING_STARTED},
      { label: 'Staining Completed', value: BeadChipStatus.STAINING_COMPLETED},
      { label: 'Drying Started', value: BeadChipStatus.DRYING_STARTED},
      { label: 'Drying Completed', value: BeadChipStatus.DRYING_COMPLETED},
      { label: 'Image Beadchip', value: BeadChipStatus.BEADCHIP_IMAGED},
      { label: 'Completed', value: BeadChipStatus.COMPLETED},
      { label: 'Delivered', value: BeadChipStatus.DELIVERED},
      { label: 'Plate Redo', value: BeadChipStatus.PLATE_REDO}
    ];
  }

  getAllActiveWorkFlowList() {
    this.workFlowData = JSON.parse(localStorage.getItem('workFlowData'));
    if(!this.workFlowData || this.workFlowData.length == 0) {
      this.blocked = true;
      this.masterDataService.getAllActiveWorkFlow(this.selectedLabId).subscribe({next:results => {
        if (results && results.data) {
          this.workFlowData = results.data;
          this.workFlowData.forEach(e => {
            this.workFlowMap.set(e.workFlowName, e);
          });
          this.blocked = false;
        }
      },
      error:(error: any) => {
          this.blocked = false;
          this.showError(error);
        }});
    } else {
      this.workFlowData.forEach(e => {
        this.workFlowMap.set(e.workFlowName, e);
      });
    }
  }

  preparePlateSearchDTO(labId: string, type?: string, status?: string, processFlowName?: string, fromDate?: Date): PlateListDTO {
    const plateListDTO = new PlateListDTO();
    plateListDTO.labId = labId;
    if (typeof type !== 'undefined') {
      plateListDTO.type = type;
    }
    if (typeof status !== 'undefined') {
      plateListDTO.status = status;
    }
    if (typeof processFlowName !== 'undefined') {
      plateListDTO.processFlowName = processFlowName;
    }
    if (fromDate !== undefined && fromDate !== null) {
      plateListDTO.fromDate = formatDate(fromDate, 'yyyy-MM-dd', 'en-US');
    }
    return plateListDTO;
  }

  fetchReceivedPlates(processFlowListString: string = undefined) {
    this.plateTableloading = true;
    let statuses = PlateStatus.RESUSPENDING_COMPLETED+","+PlateStatus.DENATURATION_STARTED+","+PlateStatus.DENATURATION_COMPLETED
    if(processFlowListString == null || processFlowListString.trim() == ""){
      processFlowListString = undefined
    }
    this.platePreparationService.fetchPlates(this.preparePlateSearchDTO(this.selectedLabId,"PLATE",statuses, processFlowListString)).subscribe({
      next : (result) => {
        this.plates = result;
        this.plateTableloading = false;
        if(this.selectedPlate.plateID != null){
          for(let i=0; i<this.plates.length; i++){
            if(this.selectedPlate.plateID == this.plates[i].plateID){
              this.tableSelectedRow = this.plates[i]
              break
            }
          }
        }
      },
      error: (error: any) => {
        this.plateTableloading = false;
        console.log("Error in fetching received plates ", error);
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plates',
          detail: 'Some issue in pulling the plates info, please try again'
        })
      }})
  }

  fetchBeadchips(status?: string[], sampleType?: string[]) {
    this.beadChipTableloading = true;
    let sampleTypeString;
    ({ sampleTypeString, status } = this.setSampleTypeAndStatus(status, sampleType));
    this.platePreparationService.fetchPlates(this.preparePlateSearchDTO(this.selectedLabId, PlateType.BEADCHIP ,status.join(','), sampleTypeString, this.fromDate)).subscribe(
      (result) => {
        this.beadChipTableloading = false;
        this.beadchipPlates = result;
        if(this.selectedPlate.plateID != null){
          for(let i=0; i<this.beadchipPlates.length; i++){
            if(this.selectedPlate.plateID == this.beadchipPlates[i].plateID){
              this.beadChipSelectedRow = this.beadchipPlates[i]
              break
            }
          }
        }
      }
    )
  }

  private setSampleTypeAndStatus(status: string[], sampleType: string[]) {
    if (status === undefined || status.length === 0) {
      status = [];
      this.filterOptions.forEach((item) => {
        if (!this.BEADCHIP_EXCLUDED_STATUSES.includes(item.value)) {
          status.push(item.value);
        }
      });
    }
    let sampleTypeString;
    if (sampleType === undefined || sampleType.length === 0) {
      sampleTypeString = undefined;
    } else {
      sampleTypeString = sampleType.join(',');
    }
    return { sampleTypeString, status };
  }

  getAllProcessFlows() {
    this.blocked = true;
    this.masterDataService.getConfigList(this.selectedLabId, 'processFlow', 0, 100, true).subscribe({next:results => {
      this.blocked = false;
      if(results && results.data){
        this.processFlows = results.data;
      }
    }, error: error => {
      this.blocked = false;
      this.showError(error);
    }})
  }

  fetchStorageLocationList(){
    this.blocked = true
    this.longtimeStorageList = [];
    this._maStorageService.fetchActiveStorageLocations(this.selectedLabId,"LONGTIME").subscribe({
      next:result => {
        this.blocked = false
        this.longtimeStorageList = result.datalist
      },
      error:error => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Error while fetching storage',
          detail:error
        })
      }
    })
  }

  fetchAllActiveMachines(){
    this.masterDataService.getConfigList(this.selectedLabId, "machine", 0, 1000).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.machinesList = results.data;
        this.machinesList.forEach(machine => {
          this.machinesBarcodeMap.set(machine.barcode, machine);
        })
      }
    )
  }

  setMapOfStatusSaves(){
    this.mapOfStatusSaves.set(BeadChipStatus.HYBRIDIZATION_STARTED, "assembleChamber");
    this.mapOfStatusSaves.set(BeadChipStatus.HYBRIDIZATION_COMPLETED, "completeHybridization");
    this.mapOfStatusSaves.set(PlateStatus.DENATURATION_STARTED, "startDenaturation");
    this.mapOfStatusSaves.set(PlateStatus.DENATURATION_COMPLETED, "completeDenaturation");
    this.mapOfStatusSaves.set(Action.INCUBATE_95C, "actionIncubate95c");
    this.mapOfStatusSaves.set(Action.INCUBATE_RT, "actionIncubateRT");
    this.mapOfStatusSaves.set(BeadChipStatus.STAINING_STARTED, "startStaining");
    this.mapOfStatusSaves.set(BeadChipStatus.STAINING_COMPLETED, "completeStaining");
    this.mapOfStatusSaves.set(BeadChipStatus.INCUBATION_STARTED, "startIncubation");
    this.mapOfStatusSaves.set(BeadChipStatus.INCUBATION_COMPLETED, "completeIncubation");
    this.mapOfStatusSaves.set(BeadChipAction.INCUBATE_58C, "actionIncubate58C");
    this.mapOfStatusSaves.set(BeadChipStatus.DRYING_STARTED, "startDrying");
    this.mapOfStatusSaves.set(BeadChipStatus.DRYING_COMPLETED, "completeDrying");
    this.mapOfStatusSaves.set(BeadChipStatus.BEADCHIP_IMAGED, "startImageBeadChip");
    this.mapOfStatusSaves.set(BeadChipStatus.COMPLETED, "resultFileSent");
  }

  setMapOfProcessStepsStatus(){
    this.mapOfProcessStepsStatus.set(BeadChipStatus.LOADED,[]);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.HYBRIDIZATION_STARTED, [BeadChipProcessStep.HYBRIDIZATION]);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.HYBRIDIZATION_COMPLETED, []);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.GENE_TITAN_LOADED, [])
    this.mapOfProcessStepsStatus.set(BeadChipStatus.STAINING_STARTED, [BeadChipProcessStep.STAINING]);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.STAINING_COMPLETED, []);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.INCUBATION_STARTED, []);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.INCUBATION_COMPLETED, []);
    this.mapOfProcessStepsStatus.set(Action.INCUBATE_95C,[]);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.DRYING_STARTED, []);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.DRYING_COMPLETED, []);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.BEADCHIP_IMAGED, []);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.COMPLETED, []);
  }

  setMapOfProcessStepsFlow(){
    // This map holds the flow of process steps that a beadchip has to go through
    this.mapOfProcessStepsFlow.set(BeadChipProcessStep.HYBRIDIZATION, [BeadChipProcessStep.LOADING])
    this.mapOfProcessStepsFlow.set(ProcessStep.DENATURATE_DNA,[ProcessStep.RESUSPEND_DNA])
    this.mapOfProcessStepsFlow.set(BeadChipProcessStep.INCUBATION, [BeadChipProcessStep.HYBRIDIZATION])
    this.mapOfProcessStepsFlow.set(BeadChipProcessStep.STAINING, [BeadChipProcessStep.INCUBATION])
    this.mapOfProcessStepsFlow.set(BeadChipProcessStep.DRYING, [BeadChipProcessStep.STAINING])
    this.mapOfProcessStepsFlow.set(BeadChipProcessStep.EVALUTION, [BeadChipProcessStep.DRYING])
  }

  setMapOfProcessStepAndAction(){
    this.mapOfProcessStepAndAction.set(BeadChipProcessStep.HYBRIDIZATION, [])
    this.mapOfProcessStepAndAction.set(ProcessStep.DENATURATE_DNA, [Action.INCUBATE_95C, Action.INCUBATE_RT])
    this.mapOfProcessStepAndAction.set(BeadChipProcessStep.INCUBATION, [BeadChipAction.INCUBATE_58C])
    this.mapOfProcessStepAndAction.set(BeadChipProcessStep.STAINING, [])
    this.mapOfProcessStepAndAction.set(BeadChipProcessStep.DRYING, [])
    this.mapOfProcessStepAndAction.set(BeadChipProcessStep.EVALUTION, [])
  }

  setMapOfActionRuntime(){
    this.mapOfActionRuntime.set(BeadChipAction.INCUBATE_58C, 960)
    this.mapOfActionRuntime.set(Action.INCUBATE_RT, 30)
    this.mapOfActionRuntime.set(Action.INCUBATE_95C, 20)
  }

  setMapOfStatusAndLabel(){
    this.mapOfStatusAndLabel.set(BeadChipStatus.HYBRIDIZATION_STARTED, "Assemble Chamber")
    this.mapOfStatusAndLabel.set(BeadChipStatus.HYBRIDIZATION_COMPLETED, "Complete Hybrid.")
    this.mapOfStatusAndLabel.set(PlateStatus.DENATURATION_STARTED,"Start Denaturation")
    this.mapOfStatusAndLabel.set(PlateStatus.DENATURATION_COMPLETED,"Complete Denatu.")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_95C,"Incubate 95°C")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_RT,"Incubate RT")
    this.mapOfStatusAndLabel.set(BeadChipStatus.STAINING_STARTED,"Start Staining")
    this.mapOfStatusAndLabel.set(BeadChipStatus.STAINING_COMPLETED,"Complete Staining")
    this.mapOfStatusAndLabel.set(BeadChipStatus.INCUBATION_STARTED,"Start Incubation")
    this.mapOfStatusAndLabel.set(BeadChipAction.INCUBATE_58C,"Incubate 58°C")
    this.mapOfStatusAndLabel.set(BeadChipStatus.INCUBATION_COMPLETED,"Complete Incubation")
    this.mapOfStatusAndLabel.set(BeadChipStatus.DRYING_STARTED,"Start Drying")
    this.mapOfStatusAndLabel.set(BeadChipStatus.DRYING_COMPLETED,"Complete Drying")
    this.mapOfStatusAndLabel.set(BeadChipStatus.BEADCHIP_IMAGED,"Image BeadChip")
    this.mapOfStatusAndLabel.set(BeadChipStatus.RESULT_FILE_SENT,"Result File Sent")
  }

  assignPlateView() {
    let processFlowData: any[] = JSON.parse(localStorage.getItem('selectedProcessFlows'));
    if(processFlowData && processFlowData.length == 1) {
      if(processFlowData[0].axiom384Propel && processFlowData[0].manualPreparation) {
        this.selectedProcessFlow = BeadChipProcessFlows.AXIOM_384;
        this.mapOfProcessStepAndAction.set(BeadChipProcessStep.HYBRIDIZATION, [])
      } else {
        this.selectedProcessFlow = BeadChipProcessFlows.OLD_FLOW;
        this.mapOfProcessStepAndAction.set(BeadChipProcessStep.HYBRIDIZATION, [])
      }
      this.plateViewSelectionDone = true;
    } else if(processFlowData && processFlowData.length > 1) {
      this.beadChipToSearch = '';
      this.plateViewSelectionDone = false;
    } else {
      this._messagesService.addErrorMessage({severity: 'error', summary: 'No process flow found', detail: 'No processflow found. Please configure process flows and try again'});
      this.plateViewSelectionDone = false;
    }
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  selectPlateView(processFlowName: string, plateType: string) {
    if(!processFlowName){
      this._messagesService.addErrorMessage({severity: 'error', summary: 'No process flow found for plate'});
      this.plateViewSelectionDone = false;
      return;
    }
    this.platePreparationService.getProcessFlow(processFlowName, this.selectedLabId).subscribe({
      next : (result) => {
        if(result.data) {
          this.selectedProcessFlowConfig = result.data;
          if(this.selectedProcessFlowConfig.axiom384Propel && this.selectedProcessFlowConfig.manualPreparation) {
            this.selectedProcessFlow = BeadChipProcessFlows.AXIOM_384;
            if(plateType == PlateType.PLATE) {
              this.axiom384Plate1 = this.selectedPlate
              this.axiom384PlateID1 = this.selectedPlate.lastUpdatedPlateID;
              if(this.selectedPlate.beadChips && this.selectedPlate.beadChips.length > 0) {
                this.platePreparationService.fetchPlate(this.selectedPlate.beadChips[0].beadChipID,this.selectedLabId).subscribe(res=>{
                  this.beadChipDetails = res
                });
              }
            }
          } else {
            this.selectedProcessFlow = BeadChipProcessFlows.OLD_FLOW;
            this.mapOfProcessStepAndAction.set(BeadChipProcessStep.HYBRIDIZATION, [])
          }
          this.plateViewSelectionDone = true;
        } else {
          this._messagesService.addErrorMessage({severity:'error', summary: 'No process flow found',
            detail:'Please configure process flow in master data to help decide correct plate view.'});
        }
      },
      error: (error: any) => {
        this.blocked = false;
        this.plateViewSelectionDone = false;
        this.showError(error);
      }

    });
  }

  resetData(){
    this.selectedPlate = new Plate();
    this.scannedPlate1 = this.resetPlate();
    this.scannedPlate2 = this.resetPlate();
    this.scannedPlate3 = this.resetPlate();
    this.selectedBeadChipPlate = new Plate();
    this.selectedPlateStepsMap = new Map();

    this.axiom384Plate1 = new Plate();
    this.axiom384PlateID1 = "";
  }

  prepareBeadchipLayoutMaps(){
    this.beadchip1LayoutMapping.set('A1', '00')
    this.beadchip1LayoutMapping.set('A3', '01')
    this.beadchip1LayoutMapping.set('A5', '02')
    this.beadchip1LayoutMapping.set('A2', '10')
    this.beadchip1LayoutMapping.set('A4', '11')
    this.beadchip1LayoutMapping.set('A6', '12')
    this.beadchip1LayoutMapping.set('B1', '20')
    this.beadchip1LayoutMapping.set('B3', '21')
    this.beadchip1LayoutMapping.set('B5', '22')
    this.beadchip1LayoutMapping.set('B2', '30')
    this.beadchip1LayoutMapping.set('B4', '31')
    this.beadchip1LayoutMapping.set('B6', '32')
    this.beadchip1LayoutMapping.set('C1', '40')
    this.beadchip1LayoutMapping.set('C3', '41')
    this.beadchip1LayoutMapping.set('C5', '42')
    this.beadchip1LayoutMapping.set('C2', '50')
    this.beadchip1LayoutMapping.set('C4', '51')
    this.beadchip1LayoutMapping.set('C6', '52')
    this.beadchip1LayoutMapping.set('D1', '60')
    this.beadchip1LayoutMapping.set('D3', '61')
    this.beadchip1LayoutMapping.set('D5', '62')
    this.beadchip1LayoutMapping.set('D2', '70')
    this.beadchip1LayoutMapping.set('D4', '71')
    this.beadchip1LayoutMapping.set('D6', '72')
    this.beadchip1LayoutMapping.set('E1', '80')
    this.beadchip1LayoutMapping.set('E3', '81')
    this.beadchip1LayoutMapping.set('E5', '82')
    this.beadchip1LayoutMapping.set('E2', '90')
    this.beadchip1LayoutMapping.set('E4', '91')
    this.beadchip1LayoutMapping.set('E6', '92')
    this.beadchip1LayoutMapping.set('F1', '100')
    this.beadchip1LayoutMapping.set('F3', '101')
    this.beadchip1LayoutMapping.set('F5', '102')
    this.beadchip1LayoutMapping.set('F2', '110')
    this.beadchip1LayoutMapping.set('F4', '111')
    this.beadchip1LayoutMapping.set('F6', '112')
    this.beadchip1LayoutMapping.set('G1', '120')
    this.beadchip1LayoutMapping.set('G3', '121')
    this.beadchip1LayoutMapping.set('G5', '122')
    this.beadchip1LayoutMapping.set('G2', '130')
    this.beadchip1LayoutMapping.set('G4', '131')
    this.beadchip1LayoutMapping.set('G6', '132')
    this.beadchip1LayoutMapping.set('H1', '140')
    this.beadchip1LayoutMapping.set('H3', '141')
    this.beadchip1LayoutMapping.set('H5', '142')
    this.beadchip1LayoutMapping.set('H2', '150')
    this.beadchip1LayoutMapping.set('H4', '151')
    this.beadchip1LayoutMapping.set('H6', '152')

    this.beadchip2LayoutMapping.set('A7', '00')
    this.beadchip2LayoutMapping.set('A9', '01')
    this.beadchip2LayoutMapping.set('A11', '02')
    this.beadchip2LayoutMapping.set('A8', '10')
    this.beadchip2LayoutMapping.set('A10', '11')
    this.beadchip2LayoutMapping.set('A12', '12')
    this.beadchip2LayoutMapping.set('B7', '20')
    this.beadchip2LayoutMapping.set('B9', '21')
    this.beadchip2LayoutMapping.set('B11', '22')
    this.beadchip2LayoutMapping.set('B8', '30')
    this.beadchip2LayoutMapping.set('B10', '31')
    this.beadchip2LayoutMapping.set('B12', '32')
    this.beadchip2LayoutMapping.set('C7', '40')
    this.beadchip2LayoutMapping.set('C9', '41')
    this.beadchip2LayoutMapping.set('C11', '42')
    this.beadchip2LayoutMapping.set('C8', '50')
    this.beadchip2LayoutMapping.set('C10', '51')
    this.beadchip2LayoutMapping.set('C12', '52')
    this.beadchip2LayoutMapping.set('D7', '60')
    this.beadchip2LayoutMapping.set('D9', '61')
    this.beadchip2LayoutMapping.set('D11', '62')
    this.beadchip2LayoutMapping.set('D8', '70')
    this.beadchip2LayoutMapping.set('D10', '71')
    this.beadchip2LayoutMapping.set('D12', '72')
    this.beadchip2LayoutMapping.set('E7', '80')
    this.beadchip2LayoutMapping.set('E9', '81')
    this.beadchip2LayoutMapping.set('E11', '82')
    this.beadchip2LayoutMapping.set('E8', '90')
    this.beadchip2LayoutMapping.set('E10', '91')
    this.beadchip2LayoutMapping.set('E12', '92')
    this.beadchip2LayoutMapping.set('F7', '100')
    this.beadchip2LayoutMapping.set('F9', '101')
    this.beadchip2LayoutMapping.set('F11', '102')
    this.beadchip2LayoutMapping.set('F8', '110')
    this.beadchip2LayoutMapping.set('F10', '111')
    this.beadchip2LayoutMapping.set('F12', '112')
    this.beadchip2LayoutMapping.set('G7', '120')
    this.beadchip2LayoutMapping.set('G9', '121')
    this.beadchip2LayoutMapping.set('G11', '122')
    this.beadchip2LayoutMapping.set('G8', '130')
    this.beadchip2LayoutMapping.set('G10', '131')
    this.beadchip2LayoutMapping.set('G12', '132')
    this.beadchip2LayoutMapping.set('H7', '140')
    this.beadchip2LayoutMapping.set('H9', '141')
    this.beadchip2LayoutMapping.set('H11', '142')
    this.beadchip2LayoutMapping.set('H8', '150')
    this.beadchip2LayoutMapping.set('H10', '151')
    this.beadchip2LayoutMapping.set('H12', '152')
  }

  updateSelectedWorkFlowObject(workFlowName){
    this.selectedWorkFlow = this.workFlowMap.get(workFlowName)
  }

  resetPlate(plateIndex?: number){
    let plate = new Plate();
    plate.beadChips = [];
    plate.beadChips.push(this.defaultBeadchip());
    plate.beadChips.push(this.defaultBeadchip());
    if (plateIndex==undefined){
      return plate;
    }
    else{
      switch(plateIndex){
        case 1:
          this.scannedPlate1 = plate;
          break;
        case 2:
          this.scannedPlate2 = plate;
          break;
        case 3:
          this.scannedPlate3 = plate;
          break;
      }
      return ;
    }
  }

  defaultBeadchip(){
    let beadchip = new BeadChip();
    beadchip.beadChipID = ""
    beadchip.active = true;
    beadchip.singleRedo = false;
    beadchip.plateRedo = false;
    beadchip.processSteps = []
    beadchip.comments = []
    beadchip.lots = []
    beadchip.sampleIDs = []
    return beadchip;
  }

  saveBeadChipStatus(status: string,stage: number, stepName: string, actionName: string, actionPos: number) {
    if(this.multiBeadChip){
      this.multiStage = stage;
      this.multiActionName = actionName;
      this.multiActionPos =  actionPos;
      this.multiStepName = stepName;
      this.multiUpdateStatus = status;
      this.multiUpdateStatusLabel = this.mapOfStatusAndLabel.has(status) ? this.mapOfStatusAndLabel.get(status) : status;

      if(stage==ProcessStepStage.start){
        this.multiUpdateButtonStyleClass = "startButton"
      }else if(stage==ProcessStepStage.end){
        this.multiUpdateButtonStyleClass = "endButton"
      }else{
        this.multiUpdateButtonStyleClass = "VioletButtons"
      }
      this.enteredBeadChipId ="";
      this.multiUpdateBeadChipList = [];
      this.multiUpdateInputLabel = "Scan BeadChip"
      setTimeout(()=>{
        this.findAndHighlightElement("popup-beadchipid")
      }, 10)

      this.showConfirmBeadChipsPopup = true;
    }
    else{
      let funtionName = this.mapOfStatusSaves.get(status);
      this[funtionName](status);
    }
  }

  savePlateStatus(status: string,stage: number, stepName: string, actionName: string, actionPos: number) {
    if(this.multiBeadChip){
      this.multiStage = stage;
      this.multiActionName = actionName;
      this.multiActionPos =  actionPos;
      this.multiStepName = stepName;
      this.multiUpdateStatus = status;
      this.multiUpdateStatusLabel = this.mapOfStatusAndLabel.has(status) ? this.mapOfStatusAndLabel.get(status) : status;

      if(stage==ProcessStepStage.start){
        this.multiUpdateButtonStyleClass = "startButton"
      }else if(stage==ProcessStepStage.end){
        this.multiUpdateButtonStyleClass = "endButton"
      }else{
        this.multiUpdateButtonStyleClass = "VioletButtons"
      }
      this.enteredBeadChipId ="";
      this.multiUpdateBeadChipList = [];
      this.multiUpdateInputLabel = "Scan WGA Plate"
      setTimeout(()=>{
        this.findAndHighlightElement("popup-plateid")
      }, 10)

      this.showConfirmPlatesPopup = true;
    }
    else{
      let funtionName = this.mapOfStatusSaves.get(status);
      this[funtionName](status);
    }
  }

  searchPlateForBeadchipLoading(wgaPlateID: string, beadchipPosition: number){
    if(undefined===wgaPlateID || ''===wgaPlateID){
      return;
    }
    if((this.scannedPlate1.wgaPlateID === wgaPlateID && 1 != beadchipPosition) || (this.scannedPlate2.wgaPlateID === wgaPlateID && 2 != beadchipPosition) || (this.scannedPlate3.wgaPlateID === wgaPlateID && 3 != beadchipPosition) ){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'WGA Plate already scanned',
        detail: 'WGA Plate Already Scanned. Please scan a new plate.',
      });
      switch(beadchipPosition){
        case 1:
          this.scannedPlate1.wgaPlateID = '';
          this.findAndHighlightElement("scan-plate-"+beadchipPosition);
          break;
        case 2:
          this.scannedPlate2.wgaPlateID = '';
          this.findAndHighlightElement("scan-plate-"+beadchipPosition);
          break;
        case 3:
          this.scannedPlate3.wgaPlateID = '';
          this.findAndHighlightElement("scan-plate-"+beadchipPosition);
          break;
      }
      return;
    }
    this.platePreparationService.fetchPlateByWGAPlateId(wgaPlateID, this.selectedLabId).subscribe({
      next:(result) => {
        let plate: Plate = result;
        if(plate.status==PlateStatus.COMPLETLY_TRANSFERED){
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Invalid action',
            detail: 'Plate has already been transferred'
          })
          return;
        }
        switch(beadchipPosition){
          case 1:
            this.scannedPlate1 = plate;
            this.checkForPlateBeadchips(this.scannedPlate1);
            this.findAndHighlightElement("scan-beadchip-"+beadchipPosition+"-1");
            break;
          case 2:
            this.scannedPlate2 = plate;
            this.checkForPlateBeadchips(this.scannedPlate2);
            this.findAndHighlightElement("scan-beadchip-"+beadchipPosition+"-1");
            break;
          case 3:
            this.scannedPlate3 = plate;
            this.checkForPlateBeadchips(this.scannedPlate3);
            this.findAndHighlightElement("scan-beadchip-"+beadchipPosition+"-1");
            break;
        }
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Success',
          detail: 'WGAPlate '+wgaPlateID+' is valid'
        })
      },error: (error) => {
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plate info',
          detail: error.error
        });
        switch(beadchipPosition){
          case 1:
            this.scannedPlate1.wgaPlateID = '';
            this.findAndHighlightElement("scan-plate-"+beadchipPosition);
            break;
          case 2:
            this.scannedPlate2.wgaPlateID = '';
            this.findAndHighlightElement("scan-plate-"+beadchipPosition);
            break;
          case 3:
            this.scannedPlate3.wgaPlateID = '';
            this.findAndHighlightElement("scan-plate-"+beadchipPosition);
            break;
        }
      }
    })
  }

  checkForPlateBeadchips(plate: Plate){
    if(!plate || (plate.beadChips && plate.beadChips.length>0)){
      return;
    }
    if(!plate.beadChips || plate.beadChips.length==0){
      plate.beadChips = []
      plate.beadChips.push(this.defaultBeadchip());
      plate.beadChips.push(this.defaultBeadchip());
    }
  }

  validateBeadchipID(beadchipPosition, beadchipIdPos){
    const arrayID = (this[`scannedPlate${beadchipPosition}`] as Plate).beadChips[beadchipIdPos - 2].beadChipID;
    if(arrayID.length > this.selectedWorkFlow.maxArrayIDSize){
      this._messagesService.addWarningMessage({
        severity:'warn',summary:'Max limit on array ID excedeed!!!',
        detail:`Please provide an ID of length less than ${this.selectedWorkFlow.maxArrayIDSize}`
      });
      return;
    }
    this.findAndHighlightElement("scan-beadchip-"+beadchipPosition+"-"+beadchipIdPos);
  }

  findAndHighlightElement(elementId){
    let element = document.getElementById(elementId);
    if(element){
      element.focus();
    }
  }

  disableLoadBeadchipButton(){
    let disable = true;
    if(this.selectedProcessFlow==BeadChipProcessFlows.OLD_FLOW){
      for(let i=1;i<4;i++){
        let plate = "scannedPlate"+i;
        let beadchips = this[plate].beadChips;
        if (undefined != this[plate].wgaPlateID && '' != this[plate].wgaPlateID && PlateStatus.DENATURATION_COMPLETED == this[plate].status){
          if(beadchips[0].beadChipID && beadchips[0].beadChipID!='' && beadchips[1].beadChipID && beadchips[1].beadChipID!=''){
              disable = false;
          }
          else{
              disable = true
          }
        }
      }
    }else {
      disable = true;
    }
    return disable;
  }

  loadBeadChips(){
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    if(this.selectedProcessFlow==BeadChipProcessFlows.OLD_FLOW){
      for(let i=1;i<4;i++){
        let plate = "scannedPlate"+i;
        let beadchips = this[plate].beadChips;
        if (undefined != this[plate].wgaPlateID && '' != this[plate].wgaPlateID){
          if(beadchips[0].beadChipID && beadchips[0].beadChipID!='' && beadchips[1].beadChipID && beadchips[1].beadChipID!=''){
              this.loadBeadchipForIllumina(this[plate],i);
          }
        }
      }
    }else{
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Invalid process flow',
        detail: 'Selected plate has neither OFH nor AXIOM384 as process flow'
      })
    }
    this.multiBeadChip = true;
  }

  toggleBeadChipView(){
    if(this.selectedBeadChipPlate && this.selectedBeadChipPlate.plateID){
      this.beadChipViewSelected = !this.beadChipViewSelected
    }
    else if(this.selectedProcessFlow == BeadChipProcessFlows.AXIOM_384){
      this.axiom384PlateBool = !this.axiom384PlateBool
    }
  }

  loadBeadchipForIllumina(scannedPlate: Plate, scannedPlateIndex: number){
    let loadBeadchipOFH = new LoadBeadchipOFH();
    loadBeadchipOFH.processFlow = BeadChipProcessFlows.OLD_FLOW
    loadBeadchipOFH.plateID = scannedPlate.plateID
    loadBeadchipOFH.beadchipID1 = scannedPlate.beadChips[0].beadChipID
    loadBeadchipOFH.beadchipID2 = scannedPlate.beadChips[1].beadChipID
    loadBeadchipOFH.puid = this.puid;
    loadBeadchipOFH.datetime = new Date()
    loadBeadchipOFH.workFlow = scannedPlate.workFlow
    loadBeadchipOFH.sampleType = scannedPlate.sampleType
    loadBeadchipOFH.sender = scannedPlate.sender
    loadBeadchipOFH.processFlowName = scannedPlate.processFlowName

    scannedPlate.status = PlateStatus.COMPLETLY_TRANSFERED
    scannedPlate.beadChips[0].sourcePlateID = scannedPlate.plateID
    scannedPlate.beadChips[0].status = ""
    scannedPlate.beadChips[0].processSteps = []
    scannedPlate.beadChips[0].minimumTemperature = ""
    scannedPlate.beadChips[0].maximumTemperature = ""
    scannedPlate.beadChips[0].archiveData = []
    scannedPlate.beadChips[1].sourcePlateID = scannedPlate.plateID
    scannedPlate.beadChips[1].status = ""
    scannedPlate.beadChips[1].processSteps = []
    scannedPlate.beadChips[1].minimumTemperature = ""
    scannedPlate.beadChips[1].maximumTemperature = ""
    scannedPlate.beadChips[1].archiveData = []
    let samples = []
    for(let sample of scannedPlate.samples){
      let pos: string = sample.position
      if(this.beadchip1LayoutMapping.has(pos)){
        sample.beadChipID = scannedPlate.beadChips[0].beadChipID
        sample.beadChipPosition = this.beadchip1LayoutMapping.get(pos)
        samples.push(sample)
      }else{
        sample.beadChipID = scannedPlate.beadChips[1].beadChipID
        sample.beadChipPosition = this.beadchip2LayoutMapping.get(pos)
        samples.push(sample)
      }
    }

    loadBeadchipOFH.samples = samples
    this.blocked = true;
    this.platePreparationService.loadBeadchips(this.selectedLabId, loadBeadchipOFH).subscribe({
      next : (res) => {
        this.blocked = false;
        if(res=="Success"){
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Beadchips has been loaded successfully',
            detail: 'Beadchips '+ loadBeadchipOFH.beadchipID1 +',' + loadBeadchipOFH.beadchipID2+' are loaded successfully'
          });
          this.onApplyFilter();
          this.resetPlate(scannedPlateIndex);
          this.platePreparationService.updatePlate(scannedPlate.plateID, scannedPlate, this.selectedLabId).subscribe({
            next : (_result) => {
              this._messagesService.addSuccessMessage({
                severity: 'success', summary: 'Source plate is updated',
                detail: 'Source plate '+ scannedPlate.plateID+' is completely transferred'
              });
            }, error: (error: any) => {
              this._messagesService.addErrorMessage({
                severity: 'error', summary: 'Failed to transfer the plate',
                detail: error.error
              })
            }
          });
        }else{
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Failed to load beadchips',
            detail: 'Failed to load beadchips '+ loadBeadchipOFH.beadchipID1 +',' + loadBeadchipOFH.beadchipID2+', please try again'
          })
        }
      }, error: (err: any) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to load beadchips',
          detail: 'Failed to load beadchips '+ loadBeadchipOFH.beadchipID1 +',' + loadBeadchipOFH.beadchipID2+', please try again'
        })
      }
    })
  }



  parseSourcePlates(plate: Plate): string{
    if(!plate || this.isEmptyString(plate.plateID) || !plate.sourcePlates || plate.sourcePlates.length<1){
      return "";
    }
    return plate.sourcePlates.map(plate => this.selectedProcessFlow === BeadChipProcessFlows.AXIOM_384 ? plate.lastUpdatedPlateID : plate.plateID).join(",");
  }

  searchForBeadChip() {
    if(!this.beadChipToSearch || this.beadChipToSearch===''){
      this.removeBeadChipSelection();
      return;
    }
    this.multiBeadChip = false;
    this.multiChemicalEdit = false;
    this.searchForBeadChipAction(this.beadChipToSearch);

  }


  assembleChamber(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.HYBRIDIZATION, ProcessStepStage.start, "")){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChipPlate();
  }

  startDenaturation(status: string){
    if(!this.updatePlateProcessStep(ProcessStep.DENATURATE_DNA, ProcessStepStage.start, "")){
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate();
  }

  actionIncubate95c(status: string){
    if(!this.updatePlateProcessStep(ProcessStep.DENATURATE_DNA, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionIncubateRT(status: string){
    if(!this.updatePlateProcessStep(ProcessStep.DENATURATE_DNA, ProcessStepStage.action, status)){
      return;
    }
    this.showWarningMessage(ProcessStep.DENATURATE_DNA, Action.INCUBATE_95C)
    this.updatePlate();
  }

  completeDenaturation(status: string){
    if(!this.updatePlateProcessStep(ProcessStep.DENATURATE_DNA, ProcessStepStage.end, "")){
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate();
  }

  startStaining(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.STAINING, ProcessStepStage.start, "")){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChipPlate();
  }

  completeStaining(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.STAINING, ProcessStepStage.end, "")){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChipPlate();
  }

  startIncubation(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.INCUBATION, ProcessStepStage.start, "")){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChipPlate();
  }

  actionIncubate58C(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.INCUBATION, ProcessStepStage.action, status)){
      return;
    }
    this.updateBeadChipPlate();
  }

  completeIncubation(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.INCUBATION, ProcessStepStage.end, "")){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChipPlate();
  }

  startDrying(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.DRYING, ProcessStepStage.start, "")){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChipPlate();
  }

  completeDrying(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.DRYING, ProcessStepStage.end, "")){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChipPlate();
  }

  startImageBeadChip(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.EVALUTION, ProcessStepStage.start, "")){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChipPlate();
  }

  resultFileSent(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.EVALUTION, ProcessStepStage.end, "")){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChipPlate();
  }

  completeHybridization(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.HYBRIDIZATION, ProcessStepStage.end, "")){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChipPlate();
  }

  showWarningMessage(stepName:string,actionName:string){
    let actionStartTime: Date = this.getProcessStepActionTimeStamp(stepName, actionName);
    let actionRunTime: number = this.selectedPlateStepsMap.get(stepName).actionMap.get(actionName).actionRunTime;
     if(this.calculatingTimes(this.calculateRemainingTime(actionRunTime, actionStartTime))>"00:00:00"){
      this._messagesService.addWarningMessage({
              severity: 'warn', summary: 'Timer is not at ZERO!',
              detail: "The time for action button is still running!",
            });
          }
  }


  disableResultfilesSent(){
    if(this.selectedBeadChipPlate && this.selectedBeadChipPlate.status==BeadChipStatus.GENE_TITAN_LOADED){
      return false;
    }
    return true;
  }

  disableButton(stage: number, stepName: string, actionName: string, actionPos: number): boolean{
    if((!this.selectedPlateStepsMap || this.selectedPlateStepsMap==null || this.selectedPlateStepsMap.size < 1)){
      return false;
    }
    switch(stage){
      case ProcessStepStage.start:
        return this.disableProcessStepStart(stepName,this.selectedPlateStepsMap);
      case ProcessStepStage.end:
        return this.disableProcessStepEnd(stepName,this.selectedPlateStepsMap);
      case ProcessStepStage.action:
        return this.disableProcessStepAction(stepName, actionName, actionPos,this.selectedPlateStepsMap);
      default:
        return true;
    }
  }

  disableProcessStepStart(stepName: string, selectedPlateStepsMap:Map<string, Step>): boolean {
    let dependentSteps: string[] = this.mapOfProcessStepsFlow.get(stepName);
    let disable: boolean = true;
    for(let step of dependentSteps){
      if(step==BeadChipProcessStep.LOADING){
        disable = !selectedPlateStepsMap.has(step) || this.isEmptyString(selectedPlateStepsMap.get(step).startPUID) || this.isEmptyDate(selectedPlateStepsMap.get(step).startTimeStamp);
        break;
      }
      let dependentProcessStep = selectedPlateStepsMap.get(step);
      if(dependentProcessStep && !this.isEmptyString(dependentProcessStep.endPUID) && !this.isEmptyDate(dependentProcessStep.endTimeStamp)){
        disable = false;
      }else{
        disable = true;
        break;
      }
    }
    if(selectedPlateStepsMap.has(stepName)){
      disable = true;
    }
    return disable;
  }

  disableProcessStepAction(stepName: string, actionName: string, actionPos: number, selectedPlateStepsMap:Map<string, Step>): boolean{
    if(!selectedPlateStepsMap.has(stepName)){
      return true;
    }
    let disable: boolean = true;
    let processStepActions : string[] = this.mapOfProcessStepAndAction.get(stepName);
    let currentProcessStep = selectedPlateStepsMap.get(stepName);
    if(actionPos==0){
      disable = currentProcessStep.actionMap.has(actionName);
    }else{
      if(!currentProcessStep.actionMap.has(actionName) && currentProcessStep.actionMap.has(processStepActions[0])){
        disable = false;
      }
    }
    if(actionName=="GENE_TITAN_LOADED" && !currentProcessStep.actionMap.has(actionName)){
      disable = !currentProcessStep.endPUID
    }
    return disable;
  }

  disableProcessStepEnd(stepName: string, selectedPlateStepsMap:Map<string, Step>): boolean {
    if(!selectedPlateStepsMap.has(stepName)){
      return true;
    }
    let disable: boolean = true;
    let processStepActions : string[] = this.mapOfProcessStepAndAction.get(stepName);
    let currentProcessStep = selectedPlateStepsMap.get(stepName);
    if(processStepActions && processStepActions.length>1){
      let previousAction = processStepActions[1];
      disable = !currentProcessStep.actionMap.has(previousAction);
    }else if(processStepActions && processStepActions.length>0){
      let previousAction = processStepActions[0];
      disable = !currentProcessStep.actionMap.has(previousAction);
    }else{
      disable = false;
    }
    if(!this.isEmptyString(currentProcessStep.endPUID) && this.isEmptyDate(currentProcessStep.endTimeStamp)){
      disable = true
      return disable
    }
    if(!this.isEmptyString(currentProcessStep.endPUID) && !this.isEmptyDate(currentProcessStep.endTimeStamp)){
      disable = true;
    }
    return disable;
  }

  isEmptyString(val: string){
    return (!val || val==null || val==='')
  }

  isEmptyDate(val: Date){
    return (!val || val==null)
  }

  isValidProcessStep(stepName: string): boolean {
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return (stepsMap.get(stepName) != undefined && stepsMap.get(stepName) != null);
  }

  isValidProcessStepAction(stepName: string, actionName: string){
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return ( stepsMap.get(stepName) != undefined && stepsMap.get(stepName) != null);
  }

  getProcessStepStartPuid(stepName: string): string {
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return stepsMap.get(stepName).startPUID;
  }

  getProcessStepEndPuid(stepName: string): string {
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return stepsMap.get(stepName).endPUID;
  }

  getProcessStepStartTimestamp(stepName: string): Date {
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return this.multiBeadChip ? stepsMap.get(stepName).startTimeStamp : this.convertUtcToLocal(stepsMap.get(stepName).startTimeStamp);
  }

  getProcessStepEndTimestamp(stepName: string): Date {
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return this.multiBeadChip ? stepsMap.get(stepName).endTimeStamp : this.convertUtcToLocal(stepsMap.get(stepName).endTimeStamp);
  }

  getProcessStepActionPuid(stepName: string, actionName: string){
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return stepsMap.get(stepName).actionMap.get(actionName).actionPUID;
  }

  getProcessStepActionTimeStamp(stepName: string, actionName: string){
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return this.multiBeadChip? stepsMap.get(stepName).actionMap.get(actionName).actionStartTime : this.convertUtcToLocal(stepsMap.get(stepName).actionMap.get(actionName).actionStartTime);
  }

  updatePlate() {
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }

    this.selectedPlate.processSteps.forEach(function(action){delete action.actionMap});
    this.selectedPlate.beadChips = [];
    this.blocked = true;
    this.platePreparationService.updatePlate(this.selectedPlate.plateID, this.selectedPlate, this.selectedLabId).subscribe({
      next : (result) => {
        this.blocked = false;
        this.selectedPlate = result;
        this.selectedPlate.beadChips = [];
        this.selectedPlate.beadChips.push(this.defaultBeadchip());
        this.selectedPlate.beadChips.push(this.defaultBeadchip());
        this.selectedPlateStepsMap = this.prepareProcessStepsMap(this.selectedPlate);
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'BeadChip '+this.selectedPlate.plateID+' is updated',
          detail: this.selectedPlate.plateID+' has been updated successfully with requested status'
        })
      }, error: (error: any) => {
        this.blocked = false;
        this.showError(error);
      }
    })
  }

  updateCompletionForOFHSamples(){
    let sampleIds = []
    this.selectedBeadChipPlate.samples?.forEach(sample => {
      sampleIds.push(sample._id);
    })
    if(sampleIds.length == 0){
      return;
    }
    let request = {};
    request['labId'] = this.selectedBeadChipPlate.labID;
    request['sampleIds'] = sampleIds;
    request['puid'] = this.puid;
    this.blocked = true;
    this.platePreparationService.updateOFHCompletedSamples(request).subscribe({
      next: (_result) => {
        this.blocked = false
      },
      error: (error) => {
        this.blocked = false;
        this.showError(error);
      }
    })
  }

  updateBeadChipPlate() {
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    this.selectedBeadChipPlate.processSteps.forEach(function(action){delete action.actionMap});
    this.blocked = true;
    this.platePreparationService.updatePlate(this.selectedBeadChipPlate.plateID, this.selectedBeadChipPlate, this.selectedLabId).subscribe({
      next : (result) => {
        this.blocked = false;
        if(this.selectedBeadChipPlate.workFlow === "OFH" && this.selectedBeadChipPlate.status === BeadChipStatus.BEADCHIP_IMAGED){
          this.updateCompletionForOFHSamples();
        }
        this.selectedBeadChipPlate = result;
        this.selectedPlateStepsMap = this.prepareProcessStepsMap(this.selectedBeadChipPlate);
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'BeadChip '+this.selectedBeadChipPlate.plateID+' is updated',
          detail: this.selectedBeadChipPlate.plateID+' has been updated successfully with requested status'
        })
      }, error: (error: any) => {
        this.blocked = false;
        this.showError(error);
      }
    })
  }

  updateMultiBeadChips(){
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    switch(this.multiStage){
      case ProcessStepStage.start:
        this.updateStartProcessForMultiplePlates()
        break;
      case ProcessStepStage.end:
        this.updateEndProcessForMultiplePlates();
        break;
      case ProcessStepStage.action:
        this.updateStartActionProcessForMultiplePlates();
        break;
    }
  }

  updateStartActionProcessForMultiplePlates() {
    let multiUpdateDto = this.getMultiUpdateDto();
    this.blocked = true;
    this.platePreparationService.updateStartActionProcessForMultiplePlates(multiUpdateDto).subscribe({
      next:(result) => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({severity: 'success', summary: 'Success', detail: result})
        this.lastUpdatedStatus = multiUpdateDto.status;
        this.updateLastUpdatedBeadChips();
        this.updateMultiPlateUpdateProcessStep(this.multiStepName, this.multiStage, this.multiActionName)
        this.closeMultiUpdatePopup();
        this.multiBeadChip = true;
      },
      error:(error) =>{
        this.blocked = false;
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    })
  }

  updateEndProcessForMultiplePlates() {
    let multiUpdateDto = this.getMultiUpdateDto();
    this.blocked = true;
    this.platePreparationService.updateEndProcessForMultiplePlates(multiUpdateDto).subscribe({
      next:(result)=>{
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result });
        this.lastUpdatedStatus = multiUpdateDto.status;
        this.updateLastUpdatedBeadChips();
        this.updateMultiPlateUpdateProcessStep(this.multiStepName, this.multiStage, this.multiActionName)
        this.closeMultiUpdatePopup();
        this.multiBeadChip = true;
      },
      error:(error) =>{
        this.blocked = false;
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    })
  }
  multiUpdateCompletionForOFHSamples(plateIds: string[]){
    let sampleIds = []
    this.multiUpdateSamplesList.forEach((samples : string[])=>{
      samples.forEach(barcode => {
        sampleIds.push(barcode);
      })
    })
    if(sampleIds.length == 0){
      return;
    }
    let request = {};
    request['labId'] = this.selectedLabId;
    request['sampleIds'] = sampleIds;
    request['puid'] = this.puid;
    this.blocked = true;
    this.platePreparationService.updateOFHCompletedSamples(request).subscribe({
      next: (_result) => {
        this.blocked = false;
      },
      error: (error) => {
        this.blocked = false;
        this.showError(error);
      }
    })
  }
  updateStartProcessForMultiplePlates() {
    let multiUpdateDto = this.getMultiUpdateDto();
    this.blocked = true;
    this.platePreparationService.updateStartProcessForMultiplePlates(multiUpdateDto).subscribe({
      next:(result) =>{
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
        this.lastUpdatedStatus = multiUpdateDto.status;
        if(multiUpdateDto.status == BeadChipStatus.BEADCHIP_IMAGED){
          this.multiUpdateCompletionForOFHSamples(multiUpdateDto.plateids)
        }
        this.updateLastUpdatedBeadChips();
        this.updateMultiPlateUpdateProcessStep(this.multiStepName, this.multiStage, this.multiActionName)
        this.closeMultiUpdatePopup();
        this.multiBeadChip = true;
      },
      error:(error) =>{
        this.blocked = false;
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    })
  }

  getMultiUpdateDto(): any {
    let multiUpdate : MultiPlateUpdate = new MultiPlateUpdate();
    multiUpdate.action = this.multiActionName;
    if(this.showConfirmPlatesPopup){
      multiUpdate.plateids = this.multiUpdatePlateInfoList;
    }
    else if(this.showConfirmBeadChipsPopup){
      multiUpdate.plateids = this.multiUpdateBeadChipList;
    }
    multiUpdate.step = this.multiStepName;
    multiUpdate.labid = this.selectedLabId;
    multiUpdate.puid = this.puid;
    multiUpdate.status = this.multiUpdateStatus;
    multiUpdate.actionRunTime = this.mapOfActionRuntime.get(this.multiActionName);
    return multiUpdate;
  }

  closeMultiUpdatePopup() {
    this.showConfirmBeadChipsPopup = false;
    this.showConfirmPlatesPopup = false;
    this.multiUpdateBeadChipList = [];
    this.multiUpdatePlateList = [];
    this.multiUpdatePlateInfoList = [];
    this.enteredBeadChipId = "";
    this.enteredPlateId = "";
    this.multiBeadChipStepsMap.clear();
    this.multiBeadChipStepsMapList = [];
    this.multiPlateStepsMap.clear();
    this.multiPlateStepsMapList = [];
    this.tableSelectedRow = null;
    this.selectedBeadChipPlate = new Plate();
    this.selectedPlate = new Plate();
    this.onApplyFilter();
  }

  deleteBeadChipFromMultiUpdateList(index: number, highlightId){
    let plateid = this.multiUpdateBeadChipList.splice(index,1);
    this.multiUpdateSamplesList.delete(plateid[0]);
    this.findAndHighlightElement(highlightId);
  }

  checkBeadChip(){
    if(this.enteredBeadChipId && this.multiUpdateBeadChipList && this.multiUpdateBeadChipList.includes(this.enteredBeadChipId)) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate BeadChip', detail: 'BeadChip already Scanned.' });
      this.enteredBeadChipId = "";
      return;
    }
    if(this.enteredBeadChipId && this.multiUpdateBeadChipList && this.multiUpdateBeadChipList.length>20) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Max BeadChips Reached', detail: '20 BeadChips already Scanned.' });
      this.enteredBeadChipId = "";
      return;
    }
    if(this.enteredBeadChipId && this.enteredBeadChipId =="") {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Empty BeadChip', detail: 'Please scan a BeadChip.' });
      return;
    }
    this.platePreparationService.processDetailsbyPlateId(this.selectedLabId, this.enteredBeadChipId, "SOURCE").subscribe({
      next:result => {
        this.fetchedBeadChipPlate = result;
        this.prepareProcessStepMapforMultiBeadChipUpdate();
        let notEligible = this.eligibleBeadChip(this.multiStage, this.multiStepName, this.multiActionName, this.multiActionPos);
        if(notEligible){
          this._messagesService.addWarningMessage({severity: 'warn', summary: 'Invalid', detail: 'Beadchip '+this.enteredBeadChipId+ ' is not eligible to perform this process step'});
          this.enteredBeadChipId = "";
        }else{
          this.multiUpdateBeadChipList.push(this.enteredBeadChipId);
          const samples:string[] = result.samples.map(sample=>sample._id);
          this.multiUpdateSamplesList.set(this.enteredBeadChipId, samples)
          this.enteredBeadChipId = "";
        }
      },error: (_error)=>{
        this._messagesService.addErrorMessage({
          severity: "error", summary: "Plate not found!",
          detail: "Plate not found with plate id - " + this.enteredBeadChipId
        })
        this.enteredBeadChipId = "";
      }
    })
  }

  deletePlateFromMultiUpdateList(index: number){
    this.multiUpdatePlateList.splice(index,1);
    this.multiUpdatePlateInfoList.splice(index,1);
    this.findAndHighlightElement('popup-plateid');
  }

  checkPlate(){
    if(this.enteredPlateId && this.multiUpdatePlateList && this.multiUpdatePlateList.includes(this.enteredPlateId)) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate Plate', detail: 'Plate already Scanned.' });
      this.enteredPlateId = "";
      return;
    }
    if(this.enteredPlateId && this.multiUpdatePlateList && this.multiUpdatePlateList.length>20) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Max Plates Reached', detail: '20 Plates already Scanned.' });
      this.enteredPlateId = "";
      return;
    }
    if(this.enteredPlateId && this.enteredPlateId =="") {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Empty Plate', detail: 'Please scan a Plate.' });
      return;
    }
    this.platePreparationService.processDetailsbyPlateId(this.selectedLabId, this.enteredPlateId, "WGA").subscribe({
      next:result => {
        this.fetchedPlate = result;
        this.prepareProcessStepMapforMultiPlateUpdate();
        let notEligible = this.eligiblePlate(this.multiStage, this.multiStepName, this.multiActionName, this.multiActionPos);
        if(notEligible){
          this._messagesService.addWarningMessage({severity: 'warn', summary: 'Invalid', detail: 'Plate '+this.enteredPlateId+ ' is not eligible to perform this process step'});
          this.enteredPlateId = "";
        }else{
          this.multiUpdatePlateInfoList.push(this.fetchedPlate.plateID);
          this.multiUpdatePlateList.push(this.enteredPlateId);
          this.enteredPlateId = "";
        }
      },error: (_error)=>{
        this._messagesService.addErrorMessage({
          severity: "error", summary: "Plate not found!",
          detail: "Plate not found with plate id - " + this.enteredPlateId
        })
        this.enteredPlateId = "";
      }
    })
  }

  prepareProcessStepMapforMultiBeadChipUpdate() {
    this.multiBeadChipStepsMap = new Map();
    if(!this.fetchedBeadChipPlate.processSteps || this.fetchedBeadChipPlate.processSteps==null)
      return;
    this.fetchedBeadChipPlate.processSteps.forEach(step => {
      step.actionMap = new Map();
      step.action.forEach(s => {
        step.actionMap.set(s.action, s);
      })
      this.multiBeadChipStepsMap.set(step.step, step);
    });
    this.multiBeadChipStepsMapList.push(this.multiBeadChipStepsMap);
  }

  prepareProcessStepMapforMultiPlateUpdate() {
    this.multiPlateStepsMap = new Map();
    if(!this.fetchedPlate.processSteps || this.fetchedPlate.processSteps==null)
      return;
    this.fetchedPlate.processSteps.forEach(step => {
      step.actionMap = new Map();
      step.action.forEach(s => {
        step.actionMap.set(s.action, s);
      })
      this.multiPlateStepsMap.set(step.step, step);
    });
    this.multiPlateStepsMapList.push(this.multiPlateStepsMap);
  }

  eligibleBeadChip(stage: number, stepName: string, actionName: string, actionPos: number){
    if((!this.multiBeadChipStepsMap || this.multiBeadChipStepsMap==null || this.multiBeadChipStepsMap.size < 1)){
      return true;
    }
    switch(stage){
      case ProcessStepStage.start:
        return this.disableProcessStepStart(stepName, this.multiBeadChipStepsMap);
      case ProcessStepStage.end:
        return this.disableProcessStepEnd(stepName, this.multiBeadChipStepsMap);
      case ProcessStepStage.action:
        return this.disableProcessStepAction(stepName, actionName, actionPos, this.multiBeadChipStepsMap);
      default:
        return true;
    }
   }

   eligiblePlate(stage: number, stepName: string, actionName: string, actionPos: number){
    if((!this.multiPlateStepsMap || this.multiPlateStepsMap==null || this.multiPlateStepsMap.size < 1)){
      return true;
    }
    switch(stage){
      case ProcessStepStage.start:
        return this.disableProcessStepStart(stepName, this.multiPlateStepsMap);
      case ProcessStepStage.end:
        return this.disableProcessStepEnd(stepName, this.multiPlateStepsMap);
      case ProcessStepStage.action:
        return this.disableProcessStepAction(stepName, actionName, actionPos, this.multiPlateStepsMap);
      default:
        return true;
    }
   }

  isPUIDPresent() {
    if (this.puid != null && this.puid != undefined && this.puid != '') {
      return true;
    }
    return false;
  }

  updateProcessStep(step: string, stage: ProcessStepStage, actionName: string, liquidHandler: string = ""): boolean{
    if(this.selectedPlateStepsMap.has(step)){
      let existingStep = this.selectedBeadChipPlate.processSteps.find(s=>s.step == step);
      if(ProcessStepStage.start==stage){
        existingStep.startTimeStamp = new Date();
        existingStep.startPUID = this.puid;
        existingStep.liquidHandler = liquidHandler;
      }else if(ProcessStepStage.end==stage){
        existingStep.endTimeStamp = new Date();
        existingStep.endLiquidHandler = liquidHandler;
        existingStep.endPUID = this.puid;
      }else{
        if(existingStep.actionMap.has(actionName)){
          let existingAction = existingStep.action.find(a => a.action == actionName);
          existingAction.actionPUID = this.puid;
          existingAction.liquidHandler = liquidHandler;
          existingAction.actionStartTime = new Date();
        }else{
          existingStep.action = (!existingStep.action || existingStep.action==null) ? [] : existingStep.action;
          let newAction = new StepAction();
          newAction.action = actionName;
          newAction.actionPUID = this.puid;
          newAction.actionStartTime = new Date();
          newAction.liquidHandler = liquidHandler;
          newAction.actionRunTime = this.mapOfActionRuntime.get(actionName)
          existingStep.action.push(newAction);
        }
      }
    }else{
      this.selectedBeadChipPlate.processSteps = (!this.selectedBeadChipPlate.processSteps || this.selectedBeadChipPlate.processSteps==null) ? [] : this.selectedBeadChipPlate.processSteps;
      let newStep = new Step();
      newStep.step = step;
      if(ProcessStepStage.start==stage){
        newStep.startTimeStamp = new Date();
        newStep.startPUID = this.puid;
        //server is forcing to put default/dummy values, otherwise it is throwing 500
        newStep.action = [];
        newStep.chemicals = [];
        newStep.liquidHandler = ""
        newStep.endPUID = "";
        newStep.endTimeStamp = null;
      }else{
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Action not allowed',
          detail: 'Process has to be started to perform this action'
        })
        return false;
      }
      this.selectedBeadChipPlate.processSteps.push(newStep)
    }
    return true;
  }

  updatePlateProcessStep(step: string, stage: ProcessStepStage, actionName: string): boolean {
    if (this.selectedPlateStepsMap.has(step)) {
      let existingStep = this.selectedPlate.processSteps.find(s => s.step == step);
      if (ProcessStepStage.start == stage) {
        existingStep.startTimeStamp = new Date();
        existingStep.startPUID = this.puid;
      } else if (ProcessStepStage.end == stage) {
        existingStep.endTimeStamp = new Date();
        existingStep.endPUID = this.puid;
      } else {
        if (existingStep.actionMap.has(actionName)) {
          let existingAction = existingStep.action.find(a => a.action == actionName);
          existingAction.actionPUID = this.puid;
          existingAction.actionStartTime = new Date();
        } else {
          existingStep.action = (!existingStep.action || existingStep.action == null) ? [] : existingStep.action;
          let newAction = new StepAction();
          newAction.action = actionName;
          newAction.actionPUID = this.puid;
          newAction.actionStartTime = new Date();
          newAction.actionRunTime = this.mapOfActionRuntime.get(actionName)
          existingStep.action.push(newAction);
        }
      }
    } else {
      this.selectedPlate.processSteps = (!this.selectedPlate.processSteps || this.selectedPlate.processSteps == null) ? [] : this.selectedPlate.processSteps;
      let newStep = new Step();
      newStep.step = step;
      if (ProcessStepStage.start == stage) {
        newStep.startTimeStamp = new Date();
        newStep.startPUID = this.puid;
        //server is forcing to put default/dummy values, otherwise it is throwing 500
        newStep.action = [];
        newStep.chemicals = [];
        newStep.liquidHandler = ""
        newStep.endPUID = "";
        newStep.endTimeStamp = null;
      } else {
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Action not allowed',
          detail: 'Process has to be started to perform this action'
        })
        return false;
      }
      this.selectedPlate.processSteps.push(newStep)
    }
    return true;
  }

  searchForSample() {
    if(!this.sampleToSearch && this.sampleToSearch===''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Enter sample ID to search',
        detail: 'Please enter something to search'
      })
      return;
    }
    this.blocked = true
    this.announcementService.getSampleFromDelivery(this.selectedLabId,this.sampleToSearch).subscribe({ next : (result) => {
      let sample = result.data[0]
      let sample_id = sample['_id']
      this.platePreparationService.fetchPlateBySample(sample_id, this.selectedLabId, PlateType.BEADCHIP).subscribe({
        next:(result)=>{
          this.blocked = false
          this._messagesService.addSuccessMessage({
            severity: 'success', detail: 'Sample search success!'
          })
          this.selectedPlate = result;
          this.selectedPlateStepsMap = this.prepareProcessStepsMap(this.selectedPlate);
        },
        error:(error)=>{
          this._messagesService.addErrorMessage({
            severity:"error",summary:"Plate not found!",
            detail:error.error.error
          })
        }
      })
   },
   error: (error: any) => {
     this._messagesService.addErrorMessage({
       severity:"error",summary:"Plate not found!",
       detail:error.error.error
     })
   }})
  }

  checkBeadChipLoadingTabActive(){
    if(this.isBeadChipLoadingSelectedFromSamplesComponent){
      this.isBeadChipLoadingSelectedFromSamplesComponent = false;
      this.onApplyFilter();
    }
    return true
  }

  fetchPlate(event) {
    this.plateSelected = true
    this.beadChipViewSelected = false
    this.axiom384PlateBool = false
    this.multiBeadChip = false;
    this.multiChemicalEdit = false;
    this.resetLastUpdatedBeadChips();
    this.searchForPlateAction(event.data.plateID);
  }

  fetchBeadchip(event) {
    this.plateSelected = false
    this.beadChipViewSelected = false
    this.axiom384PlateBool = false
    this.multiBeadChip = false;
    this.multiChemicalEdit = false;
    this.resetLastUpdatedBeadChips();
    this.searchForBeadChipAction(event.data.plateID);
  }

  updateBeadChipData(beadChipPlate: Plate){
    this.selectedBeadChipPlate = beadChipPlate;
    this.selectedPlateStepsMap = this.prepareProcessStepsMap(this.selectedBeadChipPlate);
    this.selectPlateView(this.selectedBeadChipPlate.processFlowName, PlateType.BEADCHIP);
  }

  fetchStorageNameForPlate(plateId:string){
    this.blocked = true
    this._maStorageService.searchStorageByPlate(this.selectedLabId,plateId).subscribe({
      next: storage => {
        this.blocked = false
        this.selectedPlate.storage = storage.storageName
      },
      error:error => {
        this.blocked = false
        console.error(error)
      }
    })
  }
  restorePlatesFromStorage(plates:string[] = [], callBack: () => void){
    let body = {
      "labid":this.selectedLabId,
      "plateids":plates
    }
    this.blocked = true
    this._maStorageService.removeMultiplePlatesFromStorage(body).subscribe({
      next:_result => {
        this.blocked = false
        let data = {
          'plateIDs':plates
        }
        this.blocked = true
        this._maStorageService.restorePlatesFromStorage(this.selectedLabId,data).subscribe({
          next:_result => {
            this.blocked = false
            callBack()
          },
          error:error => {
            this.blocked = false
            callBack()
            this._messagesService.addErrorMessage({
              severity:'error',summary:'Something went wrong while restoration',
              detail:error
            })
          }
        })
      },
      error:error => {
        this.blocked = false
        callBack()
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Something went wrong while restoration',
          detail:error
        })
      }
    })
  }

  searchForPlateAction(plateID: string){
    this.plateSelection= true;
    this.beadChipSelectedRow = null;
    this.selectedBeadChipPlate = new Plate();
    this.platePreparationService.fetchPlate(plateID,this.selectedLabId).subscribe({
      next:(result) => {
        this.assignValuesToSelectedPlate(result);
      },error: (error) => {
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plate info',
          detail: error.error
        })
      }
    })
  }

  prepareProcessStepsMap(plate: Plate) {
    let plateStepsMap: Map<string, Step> = new Map();
    if(!plate || plate==null){
      return plateStepsMap;
    }
    plate.processSteps.forEach(step => {
      step.actionMap = new Map();
      step.action.forEach(s => {
        step.actionMap.set(s.action, s);
      })
      plateStepsMap.set(step.step, step);
    })
    return plateStepsMap;
  }

  prepareBeadChipProcessStepsMap(beadChip: BeadChip) {
    let beadChipStepsMap: Map<string, Step> = new Map();
    if(!beadChip || beadChip==null){
      return beadChipStepsMap;
    }
    beadChip.processSteps.forEach(step => {
      step.actionMap = new Map();
      step.action.forEach(s => {
        step.actionMap.set(s.action, s);
      })
      beadChipStepsMap.set(step.step, step);
    })
    return beadChipStepsMap;
  }

  showChemicalPopup(open: boolean, processStep?: string) {

    this.selectedProcessStep = processStep;
    this.masterDataService.getAllActiveChemicals(this.selectedLabId, "chemical").subscribe({
      next : (result) => {
      this.processStepChemicals = result.data.filter(chemical => (chemical.processStep === processStep));
    }, error: (error: any) => {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
    }});

    if(this.selectedBeadChipPlate.status && !this.mapOfProcessStepsStatus.get(this.selectedBeadChipPlate.status).includes(processStep) || this.selectedBeadChipPlate.status == null){
      this.noChemicalEdit = true;
    } else {
      this.noChemicalEdit = false;
    }

    if(this.lastUpdatedStatus && !this.mapOfProcessStepsStatus.get(this.lastUpdatedStatus).includes(processStep) || this.lastUpdatedStatus == null || this.lastUpdatedStatus == '' || this.selectedPlate.plateID || this.selectedBeadChipPlate.plateID){
      this.multiChemicalEdit = false;
    } else {
      this.multiChemicalEdit = true;
    }

    this.showDialogue= true;
  }

  showError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  calculateRemainingTimeForAction(stepName: string, actionName: string){
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    if (stepsMap.get(stepName).actionMap && stepsMap.get(stepName).actionMap.get(actionName) != undefined && stepsMap.get(stepName).actionMap.get(actionName) != null) {
      let actionStartTime: Date = this.getProcessStepActionTimeStamp(stepName, actionName);
      let actionRunTime: number = stepsMap.get(stepName).actionMap.get(actionName).actionRunTime;
      return this.calculatingTimes(this.calculateRemainingTime(actionRunTime, actionStartTime));
    } else {
      let actionRunTime = this.mapOfActionRuntime.get(actionName);
      return this.calculatingTimes(actionRunTime * 60);
    }
  }

  calculatingTimes(timeLeftInSecs: number) {
    let timeLeft = Math.floor(timeLeftInSecs);
    if (timeLeft == 0)
      return "00:00:00";
    let sec = 0, min = 0, hr = 0
    if (timeLeft % 60 != 0) {
      sec = timeLeft % 60;
      timeLeft = timeLeft - sec;
    }
    timeLeft = timeLeft / 60;
    if (timeLeft % 60 != 0) {
      min = timeLeft % 60;
      timeLeft = timeLeft - min;
    }
    timeLeft = timeLeft / 60;
    hr = timeLeft;
    let secStr = "00" + sec, minStr = "00" + min, hrStr = "00" + hr
    return hrStr.substring(hrStr.length - 2) + ':' + minStr.substring(minStr.length - 2) + ":" + secStr.substring(secStr.length - 2);
  }

  calculateRemainingTime(actionRunTime: number, actionStartTime: Date) {
    let currentDateLocal = new Date();
    if(actionStartTime.getTime()+actionRunTime*60*1000 <= currentDateLocal.getTime()){
      return 0;
    }
    return (actionStartTime.getTime()+actionRunTime*60*1000 - currentDateLocal.getTime())/1000;
  }

  convertUtcToLocal(date: Date): Date{
    if(!date || date==null) return;
    let offset = new Date().getTimezoneOffset();
    let dateInLocal = new Date(date);
    dateInLocal.setMinutes(dateInLocal.getMinutes()-offset);
    return dateInLocal;
  }

  showComments(){
    this.beadChipCommentsDisplayMap.clear();
    this.beadChipCommentsDisplayMap.set("showPlateCommentList",false)
    this.beadChipCommentsMap.clear();
    let plateID ="";
    if(this.plateSelection){
      plateID = this.selectedPlate.plateID;
    } else {
      plateID = this.selectedBeadChipPlate.plateID;
    }
    this.platePreparationService.commentDetailsbyPlateId(this.selectedLabId, plateID).subscribe({
      next:(result)=>{
        this.fetchedCommentsPlate = result;
        this.selectedPlateID = this.fetchedCommentsPlate.plateID;
        this.selectedPlateStatus = this.selectedPlate.status;
        this.selectedBeadchipStatus = this.selectedBeadChipPlate.status
        this.plateCommentsList = this.fetchedCommentsPlate.comments;
        if(this.fetchedCommentsPlate && this.fetchedCommentsPlate.beadChips){
          this.fetchedCommentsPlate.beadChips.forEach(beadChip=>{
            this.beadChipCommentsMap.set(beadChip.beadChipID,beadChip.comments)
            this.beadChipCommentsDisplayMap.set(beadChip.beadChipID,false);
          })
        }
        this.showCommentDialog = true;
      },
      error:(error)=>{
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
      }
    })
  }

  hideDialog(reloadPlateData: boolean = false){
    if(reloadPlateData){
      if(this.plateSelection && this.selectedPlate.lastUpdatedPlateID){
        this.searchForPlateAction(this.selectedPlate.lastUpdatedPlateID);
      }
      if(!this.plateSelection && this.selectedBeadChipPlate.lastUpdatedPlateID){
        this.searchForBeadChipAction(this.selectedBeadChipPlate.lastUpdatedPlateID)
      }
    }
    this.showCommentDialog = false;
  }

  showMultiComments(){
    this.showMultipleCommentDialog = true;
  }

  saveMultiCommentEnabled(){
    return (this.newMultiComment == null || this.newMultiComment.trim() == '')
  }

  saveMultiComment(){
    let multiComment = new MultiCommentDTO();
    multiComment.plateids = []
    multiComment.status = this.lastUpdatedStatus;
    multiComment.comment = this.newMultiComment;
    multiComment.labid = this.selectedLabId;
    multiComment.platecomment = true;
    multiComment.puid = this.puid;
    multiComment.beadchipstatus = "";
    multiComment.beadchipids = [];
    for(let i=0;i<10;i++){
      if(this.lastUpdatedBeadChips1[i]['BeadChipId'] != '')
        multiComment.plateids.push(this.lastUpdatedBeadChips1[i]['BeadChipId']);
      if(this.lastUpdatedBeadChips2[i]['BeadChipId'] != '')
        multiComment.plateids.push(this.lastUpdatedBeadChips2[i]['BeadChipId']);
      if(this.lastUpdatedBeadChips3[i]['BeadChipId'] != '')
        multiComment.plateids.push(this.lastUpdatedBeadChips3[i]['BeadChipId']);
    }

    this.platePreparationService.updateMultiComment(multiComment).subscribe({
      next:(result) =>{
        this.newMultiComment = "";
        this.showMultipleCommentDialog = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
      },
      error:(error) =>{
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    });
  }

  hideChemicalDialog(beadChip: Plate){
    this.showDialogue = false;
    if (beadChip.plateID !== undefined)
      this.searchForBeadChipAction(beadChip.plateID);
  }

  removePlateSelection(){
    this.plateSelected = false
    this.beadChipViewSelected = false
    this.axiom384PlateBool = false
    this.tableSelectedRow = null;
    this.selectedPlate = new Plate();
    this.beadChipSelectedRow = null;
    this.multiBeadChip = true;
    this.resetData();
  }

  removeBeadChipSelection(){
    this.plateSelected = false
    this.beadChipViewSelected = false
    this.axiom384PlateBool = false
    this.beadChipSelectedRow = null;
    this.selectedBeadChipPlate = new Plate();
    this.tableSelectedRow = null;
    this.multiBeadChip = true;
    this.resetData();
  }

  workflowSelection(){
    this.blocked = true;
    this.platePreparationService.fetchPlate(this.beadChipToSearch,this.selectedLabId).subscribe({
      next:(result) => {
        this.blocked = false;
        this.selectedBeadChipPlate = result
        this.selectPlateView(this.selectedBeadChipPlate.processFlowName, PlateType.BEADCHIP);
      },error: (error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch beadchip workflow',
          detail: error.error
        })
      }
    })
  }


  searchForBeadChipAction(beadChipId: string){
    this.plateSelection= false;
    this.tableSelectedRow = null;
    this.selectedPlate = new Plate();
    this.selectedBeadChipPlate = new Plate();
    this.platePreparationService.fetchPlate(beadChipId, this.selectedLabId).subscribe({
      next:(result) => {
        this.beadChipToSearch = "";
        if(result.type == "PLATE"){
          this.assignValuesToSelectedPlate(result);
        }else{
          this.selectedBeadChipPlate = result;
          this.commentplateID = this.selectedBeadChipPlate.plateID;
          this.selectedPlateStepsMap = this.prepareProcessStepsMap(this.selectedBeadChipPlate);
          this.selectPlateView(this.selectedBeadChipPlate.processFlowName, PlateType.BEADCHIP);
          this.updateSelectedWorkFlowObject(this.selectedBeadChipPlate.workFlow);
        }
      },error: (error) => {
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch beadchip info',
          detail: error.error.error
        })
      }
    })
  }

  assignValuesToSelectedPlate(result){
    this.selectedPlate = result;
    this.plateSelection= true;
    this.commentplateID =  this.selectedPlate.plateID;
    if(this.selectedPlate.storagePlate){
      this.fetchStorageNameForPlate(this.selectedPlate.plateID)
    }
    if(this.selectedPlate.storagePlate && this.selectedPlate.status !== PlateStatus.STORAGE_PLATE){
      this.restorePlatesFromStorage([this.selectedPlate.lastUpdatedPlateID], () => {})
    }
    this.selectedPlateStepsMap = this.prepareProcessStepsMap(this.selectedPlate);
    this.selectPlateView(this.selectedPlate.processFlowName, PlateType.PLATE);
    this.updateSelectedWorkFlowObject(this.selectedPlate.workFlow);
  }

  onApplyFilter(){
    this.getProcessFlowListFromProtocolList();
    this.fetchBeadchips(this.selectedStatuses, this.selectedProcessFlowList);
    this.fetchReceivedPlates(this.selectedProcessFlowList.join(","));
  }

  resetAllFilter(){
    this.selectedStatuses = [];
    this.selectedProcessFlowList = [];
    this.selectedProtocolList = [];
    this.fromDate = undefined;
    this.fetchBeadchips();
    this.fetchReceivedPlates()
  }

  getProcessFlowListFromProtocolList(){
    this.selectedProcessFlowList = [];
    this.processFlows.forEach( processFlow => {
      for(let i=0; i<this.selectedProtocolList.length; i++){
        if(processFlow[this.selectedProtocolList[i]]){
          this.selectedProcessFlowList.push(processFlow.processFlowName)
          break;
        }
      }
    })
  }

  resetLastUpdatedBeadChips(){
    this.lastUpdatedBeadChips1 = [];
    this.lastUpdatedBeadChips2 = [];
    this.lastUpdatedBeadChips3 = [];
    this.chemicalsBeadChipids = [];
  }

  updateLastUpdatedBeadChips(){
    this.lastUpdatedBeadChips1 = [];
    this.lastUpdatedBeadChips2 = [];
    this.lastUpdatedBeadChips3 = [];
    this.chemicalsBeadChipids = [];

    let updatedList;
    if(this.multiUpdatePlateList.length != 0){
      updatedList = this.multiUpdatePlateList;
    }
    else{
      updatedList = this.multiUpdateBeadChipList;
    }

    for(let i=0;i<30;i++){
      let updatedBeadChip = { entityId : updatedList.length>i ? updatedList[i] : '' }
      if(i<10){
        this.lastUpdatedBeadChips1.push(updatedBeadChip)
      }else if(i<20){
        this.lastUpdatedBeadChips2.push(updatedBeadChip)
      }else{
        this.lastUpdatedBeadChips3.push(updatedBeadChip)
      }
      if(updatedList.length>i)
        this.chemicalsBeadChipids.push(updatedList[i]);
    }

  }

  onFileSelect(filesData) {
    if (filesData.target.files.length > 0) {
      const file = filesData.target.files[0];
      this.uploadedFile = file;
      let fileReader: FileReader = new FileReader();
      let self = this
      fileReader.onloadend = function(x) {
        self.uploadedFileContent = fileReader.result
        self.isFileNotSelected = false
      }
      fileReader.readAsText(file)
    } else {
      this.isFileNotSelected = true;
    }
  }

  fileUpload() {
    this.blocked = true;
    const formData = new FormData();
    formData.append('file', this.uploadedFile);
    this.platePreparationService.logFileUpload(this.uploadedFileContent, this.selectedLabId, this.puid).subscribe({
      next:results => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: "Success", detail: results["data"]
        });
        this.fileUploadElement.nativeElement.value = "";
        this.isFileNotSelected = true;
        if(this.selectedBeadChipPlate.plateID){
          this.searchForBeadChipAction(this.selectedBeadChipPlate.plateID);
        }
        this.onApplyFilter();
      },
      error:error => {
        this.fileUploadElement.nativeElement.value = "";
        this.isFileNotSelected = true;
        this.blocked = false;
        this._messagesService.addErrorMessage({ severity: 'error',
        summary: "Conflict", detail:error.error});
      }
    });
  }

  getProcessStepLiquidHandler(stepName){
    if (this.multiBeadChip || (this.selectedPlate.plateID == undefined && this.selectedBeadChipPlate.plateID == undefined))
      return ""
    return this.selectedPlateStepsMap.get(stepName)? this.selectedPlateStepsMap.get(stepName).liquidHandler: "";
  }

  getProcessStepActionLiquidHandler(stepName, actionName){
    if (this.multiBeadChip || (this.selectedPlate.plateID == undefined && this.selectedBeadChipPlate.plateID == undefined))
      return ""
    let processStep = this.selectedPlateStepsMap.get(stepName)? this.selectedPlateStepsMap.get(stepName): null;
    if(processStep == null)
      return ""
    return processStep.actionMap.has(actionName)?processStep.actionMap.get(actionName).liquidHandler:""
  }

  disableLiquidHandler(stepName){
    if (this.multiBeadChip || this.selectedPlate.plateID != undefined)
      return false
    else
      return true
  }

  updateMultiPlateUpdateProcessStep(step: string, stage: ProcessStepStage, actionName: string, liquidHandler=""){
    if(this.multiUpdateProcessStepsMap.has(step)){
      let existingStep = this.multiUpdateProcessStepsMap.get(step);
      if(ProcessStepStage.start==stage){
        existingStep.startTimeStamp = new Date();
        existingStep.startPUID = this.puid;
      }else if(ProcessStepStage.end==stage){
        existingStep.endTimeStamp = new Date();
        existingStep.endPUID = this.puid;
      }else{
        if(existingStep.actionMap.has(actionName)){
          let existingAction = existingStep.action.find(a => a.action == actionName);
          existingAction.actionPUID = this.puid;
          existingAction.actionStartTime = new Date();
        }else{
          existingStep.action = (!existingStep.action || existingStep.action==null) ? [] : existingStep.action;
          let newAction = new StepAction();
          newAction.action = actionName;
          newAction.actionPUID = this.puid;
          newAction.actionStartTime = new Date();
          newAction.actionRunTime = this.mapOfActionRuntime.get(actionName);
          existingStep.action.push(newAction);
          existingStep.actionMap.set(actionName, newAction)
        }
      }
    }else{
      let newStep = new Step();
      newStep.step = step;
      newStep.action = [];
      newStep.actionMap = new Map();
      if(ProcessStepStage.start==stage){
        newStep.startTimeStamp = new Date();
        newStep.startPUID = this.puid;
        newStep.liquidHandler = liquidHandler;
      }else if(ProcessStepStage.end==stage){
        newStep.endTimeStamp = new Date();
        newStep.endPUID = this.puid;
      }else{
        let newAction = new StepAction();
        newAction.action = actionName;
        newAction.actionPUID = this.puid;
        newAction.actionStartTime = new Date();
        newAction.actionRunTime = this.mapOfActionRuntime.get(actionName);
        newStep.actionMap.set(actionName, newAction);
      }
      this.multiUpdateProcessStepsMap.set(step, newStep)
    }
  }

  updateMultiPlates(){
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    switch(this.multiStage){
      case ProcessStepStage.start:
        this.updateStartProcessForMultiplePlates()
        break;
      case ProcessStepStage.end:
        this.updateEndProcessForMultiplePlates();
        break;
      case ProcessStepStage.action:
        this.updateStartActionProcessForMultiplePlates();
        break;
    }
  }

  downloadMultiSampleSheetOnAGivenDate(){
    if(!this.completeIncubationDate){
      this._messagesService.addWarningMessage({
        severity:'warn',summary:'Please select a date to download all the sample sheets'
      })
      return;
    }
    this.blocked = true
    this.platePreparationService.downloadMultiSampleSheetZip(this.selectedLabId,this.completeIncubationDate.toDateString()).subscribe({
      next:result => {
        this.blocked = false
        if(result.status === 204){
          this._messagesService.addWarningMessage({
            severity:'warn',summary:result.message
          })
          return
        }
        this._messagesService.addSuccessMessage({
          severity:'success',summary:result.filename,
          detail:`Downloading ${result.filename}`
        })
        let blob = new Blob([result.fileContent],{type:result.fileContent.type})
        saveByFileSaver(blob,result.filename)
        this.completeIncubationDate = null
      },
      error:_error => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Download failed',
          detail:`Something went wrong while downloading sample sheets for ${this.completeIncubationDate.toDateString()}`
        })
        this.completeIncubationDate = null
      }
    })
  }

  downloadSampleSheet() {
    this.blocked = true;
    this.platePreparationService.downloadSampleSheet(this.selectedLabId, this.selectedBeadChipPlate.sourcePlates[0].plateID).subscribe({next:res => {
      this.blocked = false;
      this._messagesService.addSuccessMessage({
        severity: 'success', summary: 'Sample sheet Generated Successfully',
        detail: "Sample sheet downloaded successfully"
      });
      var blob = new Blob([res.fileContent], { type: 'text/csv;' });
      console.log("File name : " + res.filename);
      saveByFileSaver(blob, res.filename);
    },
    error:error => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Sample sheet',
          detail: "Sample sheet generation failed!!"
        });

      }})
  }
  disableShampleSheet() {
    if (this.selectedBeadChipPlate && this.selectedBeadChipPlate.plateID != null) {
      return false;
    }
    return true;
  }

  showWgaStoreDialog(){
    this.wgaStoreDialog = true
    this.multiWgaPlateID = []
    this.multiOldStorageList.clear();
    this.enteredPlateId = ''
    setTimeout(() => {
      this.findAndHighlightElement('store-plate-id')
    },500)
  }

  checkIfPlateExists(){
    this.blocked = true
    this.platePreparationService.fetchPlateByWGAPlateId(this.enteredWgaPlateID,this.selectedLabId).subscribe({
      next:result => {
        this.blocked = false
        let plate: Plate = result
        if(plate.status !== PlateStatus.COMPLETLY_TRANSFERED){
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Invalid action',
            detail: 'Cannot store a plate if its not completly transfered!'
          })
          return
        }
        this.addPlateToStoreList();

      },error:_error => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity:"error",summary:'Plate not found',
          detail:'The given plate does not exist'
        })
        this.enteredWgaPlateID = ''
        this.findAndHighlightElement('store-plate-id')
      }
    })
  }

  addPlateToStoreList(){
    if(this.multiWgaPlateID.includes(this.enteredWgaPlateID)){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Plate present',
        detail: `${this.enteredWgaPlateID} is already added.`
      })
      this.enteredWgaPlateID = ''
      this.findAndHighlightElement('store-plate-id')
      return
    }

    this.blocked = true
    this._maStorageService.searchStorageByPlate(this.selectedLabId,this.enteredWgaPlateID).subscribe({
      next:result => {
        this.blocked = false
        let currentPlateStorage = result.storageName
        if(currentPlateStorage === this.selectedStorageLocation["storageName"]){
          this._messagesService.addWarningMessage({
            severity:'warn',summary:'Invalid operation',
            detail:`Plate ${this.enteredWgaPlateID} is already in ${currentPlateStorage}. Cannot move to the same location.`
          })
          this.findAndHighlightElement("store-plate-id")
          return
        }
        this.multiOldStorageList.add(currentPlateStorage)
        this.multiWgaPlateID.push(this.enteredWgaPlateID)
        this.enteredWgaPlateID = ''
        this.findAndHighlightElement('store-plate-id')
      },
      error:_error => {
        this.blocked = false
        this.multiWgaPlateID.push(this.enteredWgaPlateID)
        this.enteredWgaPlateID = ''
        this.findAndHighlightElement('store-plate-id')
      }
    })
  }

  addMultiPlateToStorage(){
    if(this.selectedStorageLocation === '' || this.selectedStorageLocation === undefined){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Storage Location Not Selected',
        detail: "Storage location cannot be empty. Please select a storage location."
      });
      return;
    }
    if(this.multiWgaPlateID.length === 0){
      this._messagesService.addErrorMessage({
        severity: 'warn', summary: 'Plates Not Added',
        detail: "Add the plates which needs to be stored"
      });
      this.findAndHighlightElement("store-plate-id")
      return
    }

    let multiPlateData = {
      "storageName":this.selectedStorageLocation["storageName"],
      "plateids": this.multiWgaPlateID,
      "labid":this.selectedLabId,
      "storageMigration": Array.from(this.multiOldStorageList)
    }
    this.blocked = true
    this._maStorageService.addMultiplePlatesToStorage(multiPlateData).subscribe({
      next:_r => {
        this.blocked = false
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Plates Added Successfully',
          detail:`${this.multiWgaPlateID.length} plates added successfully to storage ${this.selectedStorageLocation['storageName']}`
        });
        this.closeStorageDialog()

      },
      error:error => {
        this.blocked = false
        this.closeStorageDialog()
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Plate Not Added',
          detail: error.error
        });
      }
    })
  }

  removePlateFromStoreList(index: number){
    this.multiWgaPlateID.splice(index,1)
  }

  closeStorageDialog(){
    this.wgaStoreDialog = false
    this.multiWgaPlateID = []
    this.multiOldStorageList.clear()
  }

  getPriorityClass(priority:number){
    return priorityMap[priority]
  }

  checkStatusChange(plate: Plate): boolean{
    return plate?.lastModifiedDate === plate?.adminChangeTimeStamp;
  }

}
